<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-boxes"></i> สินค้าและสต๊อก</h4>

          <div class="row mx-1 my-3">
            <b-form-input
              type="search"
              class="col"
              autofocus
              v-model="filter"
              placeholder="ค้นหาสินค้า จากรหัส หมวดหมู่ หรือชื่อสินค้า"
            ></b-form-input>
            <b-button
              class="col-3 ml-3"
              variant="outline-primary"
              @click="openStockAdjustmentModal()"
            >
              <i class="fas fa-pencil-square-o"></i> ปรับปรุงสต๊อก
            </b-button>
            <b-button
              class="col-3 col-sm-4 col-md-3 ml-3"
              variant="primary"
              @click="openProductItemModal()"
            >
              <i class="fas fa-plus"></i> เพิ่มรายการ
            </b-button>
          </div>

          <b-table
            id="productManageTable"
            ref="productManageTable"
            hover
            small
            sort-icon-left
            head-variant="light"
            :items="getProductList"
            :fields="fields"
            :filter="filter"
            :filter-function="filterProducts"
            :sort-desc="true"
            :responsive="true"
          >
            <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>

            <template v-slot:cell(productPrice)="row">
              {{ formatProductPrice(row.value) }}
            </template>

            <template v-slot:cell(productStock)="row">
              <div class="product-stock-content">
                {{ formatProductStock(row.value) }}
                <i
                  class="fas fa-info-circle ml-1 info-icon"
                  @click="openProductHistoryItemModal(row.item)"
                ></i>
              </div>
            </template>

            <template v-slot:cell(buttons)="row">
              <ActionButtonGroup
                :item="row.item"
                :show-info="false"
                edit-tooltip="แก้ไขสินค้า"
                delete-tooltip="ลบสินค้า"
                @edit="editProduct"
                @delete="deleteProduct"
                :disabled-edit="row.item.productStatus !== 'ACTIVE'"
                :disabled-delete="row.item.productStatus !== 'ACTIVE'"
              />
            </template>
          </b-table>
        </div>
      </div>
      <ProductHistoryItem ref="productHistoryItemModal"></ProductHistoryItem>
      <ProductItem ref="productItemModal"></ProductItem>
      <StockAdjustmentModal ref="stockAdjustmentModal"></StockAdjustmentModal>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import ProductItem from "../../components/modal/ProductAndStock/ProductItem.vue";
import StockAdjustmentModal from "../../components/modal/ProductAndStock/StockAdjustment.vue";
import Dialog from "../../components/modal/Dialog.vue";
import { mapGetters, mapActions } from "vuex";
import Loading from "@/components/Loading";
import ProductHistoryItem from "../../components/modal/ProductAndStock/ProductHistoryItem.vue";
import ActionButtonGroup from "@/components/table/stock/button/ActionButtons.vue";

export default {
  name: "ProductInventory",
  components: {
    ProductItem,
    StockAdjustmentModal,
    Dialog,
    Loading,
    ProductHistoryItem,
    ActionButtonGroup,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "productCode",
          label: "รหัส",
          sortable: true,
          thStyle: { width: "9%" },
          tdStyle: { width: "9%" },
        },
        {
          key: "productCategory.description",
          label: "หมวดหมู่",
          sortable: true,
          thStyle: { width: "9%" },
          tdStyle: { width: "9%" },
        },
        {
          key: "productNameMain",
          label: "ชื่อสินค้า",
          sortable: true,
          thStyle: { width: "17%" },
          tdStyle: { width: "17%" },
        },
        {
          key: "productNameAdditional",
          label: "ชื่อสินค้าเพิ่มเติม",
          sortable: true,
          thStyle: { width: "16%" },
          tdStyle: { width: "16%" },
        },
        {
          key: "productStock",
          label: "จำนวนสต๊อก",
          sortable: true,
          thStyle: { width: "11%" },
          tdStyle: { width: "11%" },
          tdClass: "product-stock-cell",
        },
        {
          key: "productUnit.description",
          label: "หน่วย",
          sortable: true,
          thStyle: { width: "10%" },
          tdStyle: { width: "10%" },
        },
        {
          key: "productPrice",
          label: "ราคาต้นทุนเฉลี่ย (บาท)",
          sortable: true,
          thStyle: { width: "13%" },
          tdStyle: { width: "13%" },
        },
        {
          key: "buttons",
          label: "",
          class: "text-center",
          thStyle: { width: "9%" },
          tdStyle: { width: "9%" },
        },
      ],
      filter: "",
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getProductList: "moduleProductInventory/getProductList",
      getProductUnitList: "moduleUnitMaster/getUnitList",
      getCategoryList: "moduleCategoryMaster/getCategoryList",
      getAllGRWithProductList: "moduleProductInventory/getAllGRWithProductList",
    }),
  },
  methods: {
    ...mapActions({
      fetchProductList: "moduleProductInventory/fetchProductList",
      fetchUnitList: "moduleUnitMaster/fetchUnitList",
      fetchCategoryList: "moduleCategoryMaster/fetchCategoryList",
      fetchAllGRWithProductList:
        "moduleProductInventory/fetchAllGRWithProductList",
    }),
    async init() {
      this.isLoading = true;
      try {
        await Promise.all([
          this.fetchProductList({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          }),

          this.fetchUnitList({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          }),

          this.fetchCategoryList({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          }),

          this.fetchAllGRWithProductList({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          }),
        ]);
      } catch (err) {
        this.showDialogToast("danger", "โหลดรายการสินค้าไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    openProductItemModal(product = null) {
      this.$refs.productItemModal.show({
        product,
        unitList: this.getProductUnitList,
        categoryList: this.getCategoryList,
      });
    },
    editProduct(product) {
      this.openProductItemModal(product);
    },
    deleteProduct(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบสินค้านี้ ?",
        "คุณต้องการลบสินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;

        this.isLoading = true;

        this.$store
          .dispatch("moduleProductInventory/deleteProductItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: eventData.productId,
          })
          .then(res => {
            if (res.status == 200) {
              this.init();
              this.showDialogToast("success", "ลบรายการสินค้าสำเร็จ");
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการสินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    openProductHistoryItemModal(product) {
      this.isLoading = true;

      this.$store
        .dispatch("moduleProductInventory/getProductHistoryById", {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          id: product.productId,
        })
        .then(res => {
          const historyData = res.data.data;
          this.$refs.productHistoryItemModal.show({
            historyData,
            productUnit: product.productUnit.description,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    openStockAdjustmentModal() {
      this.$refs.stockAdjustmentModal.show({
        productList: this.getProductList,
        unitList: this.getProductUnitList,
        allGRWithProductList: this.getAllGRWithProductList,
      });
    },
    filterProducts(row, filter) {
      if (!filter || (typeof filter === "string" && !filter.trim())) {
        return true;
      }
      const s = String(filter).toLowerCase();
      const code = (row.productCode || "").toString().toLowerCase();
      const category = (
        row.productCategory?.description ??
        row.productCategory ??
        ""
      )
        .toString()
        .toLowerCase();
      const nameMain = (row.productNameMain || "").toString().toLowerCase();
      const nameAdditional = (row.productNameAdditional || "")
        .toString()
        .toLowerCase();
      return (
        code.includes(s) ||
        category.includes(s) ||
        nameMain.includes(s) ||
        nameAdditional.includes(s)
      );
    },
    formatProductPrice(value) {
      if (value == null || value === "") return "";
      const num = Number(value);
      if (Number.isNaN(num)) return "";
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatProductStock(value) {
      if (value == null || value === "") return "";
      const num = Number(value);
      if (Number.isNaN(num)) return "";
      return num.toLocaleString("en-US");
    },
  },
};
</script>

<style scoped>
.info-icon {
  color: #a3a4a6;
  cursor: pointer;
  font-size: 20px;
}

::v-deep #productManageTable thead tr th,
::v-deep #productManageTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #productManageTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #productManageTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep .product-stock-cell {
  vertical-align: middle !important;
}
::v-deep .product-stock-content {
  display: flex;
  align-items: center;
}
</style>
